/* ============================================================
   EPIC LABS® · STORE  v1.0
   Capa de persistencia a prueba de fallos para la App EPIC.
   - get/set/update JSON con try/catch (nunca rompe)
   - Auto-guardado de cualquier campo [data-epic-persist]
   - Flush garantizado antes de cerrar pestaña/sesión (sin perder progreso)
   - Respaldo espejo + recuperación si el JSON se corrompe
   - Manejo de cuota (poda respaldos viejos)
   - Eventos de cambio: document 'epic:store:change'
   Carga ANTES que epic-app.js.
   ============================================================ */
(function () {
  if (window.EpicStore) return;

  var NS = 'epic';                 // prefijo lógico
  var MIRROR = '__bk_';            // prefijo de respaldo espejo
  var pending = {};                // escrituras debounced
  var flushTimer = null;

  function safeParse(raw, d) {
    if (raw == null) return d;
    /* FIX audit #11 · si el parse falla y el default esperado es objeto/array, devolvemos
       el default (no el string corrupto) → consumidores con .forEach/.macros no crashean. */
    try { return JSON.parse(raw); } catch (e) { return (d && typeof d === 'object') ? d : raw; }
  }
  function rawGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function rawSet(k, v) {
    try { localStorage.setItem(k, v); return true; }
    catch (e) {
      /* Cuota llena: poda respaldos y reintenta una vez */
      try {
        pruneBackups();
        localStorage.setItem(k, v);
        return true;
      } catch (e2) { return false; }
    }
  }
  function pruneBackups() {
    try {
      for (var i = localStorage.length - 1; i >= 0; i--) {
        var key = localStorage.key(i);
        if (key && key.indexOf(MIRROR) === 0) localStorage.removeItem(key);
      }
    } catch (e) {}
  }

  /* ── API ───────────────────────────────────────────────── */
  var EpicStore = {
    /* Lee con recuperación: si el valor primario está corrupto, usa el espejo */
    get: function (key, def) {
      var raw = rawGet(key);
      if (raw == null) {
        var bk = rawGet(MIRROR + key);
        if (bk != null) { rawSet(key, bk); return safeParse(bk, def); } // restaura
        return def;
      }
      try { return JSON.parse(raw); }
      catch (e) {
        var b = rawGet(MIRROR + key);
        if (b != null) { try { return JSON.parse(b); } catch (e2) {} }
        /* FIX audit #11 · si el caller espera objeto/array, devolvemos def (no el string corrupto) */
        if (def && typeof def === 'object') return def;
        return raw; // string plano tolerado
      }
    },

    /* Escritura inmediata + espejo (durable). */
    set: function (key, value) {
      var s = (typeof value === 'string') ? value : JSON.stringify(value);
      var ok = rawSet(key, s);
      rawSet(MIRROR + key, s); // respaldo
      try {
        document.dispatchEvent(new CustomEvent('epic:store:change', { detail: { key: key, value: value } }));
      } catch (e) {}
      return ok;
    },

    /* Lectura-modificación-escritura segura. */
    update: function (key, fn, def) {
      var cur = EpicStore.get(key, (def === undefined ? {} : def));
      var next = fn(cur);
      if (next === undefined) next = cur;
      EpicStore.set(key, next);
      return next;
    },

    remove: function (key) {
      try { localStorage.removeItem(key); localStorage.removeItem(MIRROR + key); } catch (e) {}
    },

    /* Escritura diferida (para inputs de alta frecuencia). Flush garantizado. */
    setDeferred: function (key, value) {
      pending[key] = value;
      if (flushTimer) clearTimeout(flushTimer);
      flushTimer = setTimeout(EpicStore.flush, 400);
    },
    flush: function () {
      flushTimer = null;
      for (var k in pending) if (pending.hasOwnProperty(k)) EpicStore.set(k, pending[k]);
      pending = {};
    },

    on: function (cb) { document.addEventListener('epic:store:change', cb); }
  };

  /* Garantiza persistencia antes de cerrar / cambiar de pestaña */
  function hardFlush() { try { EpicStore.flush(); } catch (e) {} }
  window.addEventListener('pagehide', hardFlush);
  window.addEventListener('beforeunload', hardFlush);
  document.addEventListener('visibilitychange', function () { if (document.hidden) hardFlush(); });

  /* ── Auto-guardado declarativo de campos ──────────────────
     <input data-epic-persist="miClave"> se guarda y se restaura solo.
     Soporta input/textarea/select y checkbox/radio. ── */
  function fieldKey(el) { return 'epicfield_' + el.getAttribute('data-epic-persist'); }
  function restoreField(el) {
    var saved = EpicStore.get(fieldKey(el), null);
    if (saved == null) return;
    var type = (el.type || '').toLowerCase();
    if (type === 'checkbox' || type === 'radio') {
      if (type === 'checkbox') el.checked = !!saved;
      else if (el.value === saved) el.checked = true;
    } else {
      el.value = saved;
    }
    try { el.dispatchEvent(new Event('epic:restored', { bubbles: true })); } catch (e) {}
  }
  function saveField(el) {
    var type = (el.type || '').toLowerCase();
    var val;
    if (type === 'checkbox') val = el.checked;
    else if (type === 'radio') { if (!el.checked) return; val = el.value; }
    else val = el.value;
    EpicStore.setDeferred(fieldKey(el), val);
  }
  function bindFields(root) {
    (root || document).querySelectorAll('[data-epic-persist]').forEach(function (el) {
      if (el.__epicPersist) return; el.__epicPersist = true;
      restoreField(el);
      var ev = (el.tagName === 'SELECT' || el.type === 'checkbox' || el.type === 'radio') ? 'change' : 'input';
      el.addEventListener(ev, function () { saveField(el); });
      el.addEventListener('blur', function () { saveField(el); EpicStore.flush(); });
    });
  }

  window.EpicStore = EpicStore;

  function init() { bindFields(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { bindFields(e.target || document); });
})();
